/** The request that produced the error, attached by the fetch layer. */
export type RequestMeta = {
  method: string
  /** URL path with the query string stripped */
  endpoint: string
  /** Parsed error response body, when the API returned one */
  responseBody?: unknown
}

type ErrorPayload = {
  translationKey: string
  errorMessage: string
  errorCode: string
  statusCode?: number
  request?: RequestMeta
}

class HeapsError extends Error {
  public translationKey: string
  public errorMessage: string
  public errorCode: string
  public statusCode?: number
  public request?: RequestMeta

  constructor({
    translationKey,
    errorMessage,
    errorCode,
    statusCode,
    request,
  }: ErrorPayload) {
    super(errorMessage)
    this.name = this.constructor.name
    this.translationKey = translationKey
    this.errorMessage = errorMessage
    this.errorCode = errorCode.toLowerCase()
    this.statusCode = statusCode
    this.request = request

    // https://medium.com/@Nelsonalfonso/understanding-custom-errors-in-typescript-a-complete-guide-f47a1df9354c
    Object.setPrototypeOf(this, HeapsError.prototype)

    // Only works in V8 engine (Firefox will trow an error)
    if ("captureStackTrace" in Error) {
      Error.captureStackTrace(this, this.constructor)
    }
  }
}
export default HeapsError
